import React, { FormEvent, useState } from "react"
import { useSelector } from "react-redux"

import Input from "../shared/input"
import ROUTES from "../services/routes"
import { IRedux } from "../services/types"
import AuthenticationApi from "../services/api/Authentication.api"
import useHistoryCustom from "../hooks/useHistoryCustom"

const Login = () => {
  const history = useHistoryCustom()
  const [email, setEmail] = useState<string>("")
  const [password, setPassword] = useState<string>("")
  const [error, setError] = useState<string>("")
  const [loading, setLoading] = useState<boolean>(false)
  const settings = useSelector((state: IRedux) => state.settings?.extended)

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError("")

    try {
      const { token } = await AuthenticationApi.login(email, password)
      localStorage.setItem("token", token)
      window.location.pathname = "/"
    } catch (err) {
      setError(err.message)
      setLoading(false)
    }
  }

  return (
    <div className="login">
      <div className="form" style={{ margin: 0 }}>
        <form onSubmit={onSubmit} className="field">
          <Input
            value={email}
            onChange={setEmail}
            type="email"
            label="Email"
            focus
            required
          />
          <Input
            value={password}
            onChange={setPassword}
            type="password"
            label="Mot de passe"
            required
          />
          <div className="field ">
            <button
              className="button is-primary is-light is-outlined is-small"
              type="button"
              onClick={() => history.push(ROUTES.PASSWORD_FORGOT)}
            >
              J&apos;ai oublié mon mot de passe
            </button>
          </div>
          {error === "Le mot de passe est incorrect" && (
            <article className="message is-danger field">
              <div className="message-body">
                <div>
                  Mot de passe incorrect.
                  <br />
                  Si cette adresse email est la vôtre, nous vous invitons à vous
                  connecter par l’étape :
                </div>
                <div className="has-text-centered">
                  <button
                    className="button is-primary is-light is-outlined"
                    type="button"
                    onClick={() => history.push(ROUTES.PASSWORD_FORGOT)}
                    style={{ marginTop: "1.25em" }}
                  >
                    J&apos;ai oublié mon mot de passe
                  </button>
                </div>
              </div>
            </article>
          )}
          {error === "Ce compte n'existe pas" && (
            <article className="message is-danger field">
              <div className="message-body">
                <div>
                  Ce compte n'existe pas.
                  <br />
                  Si cette adresse email est la vôtre, nous vous invitons à vous
                  créer un compte par l’étape :
                </div>
                <div className="has-text-centered">
                  <button
                    className="button is-primary is-light is-outlined"
                    type="button"
                    onClick={() => history.push(ROUTES.CREATE_ACCOUNT)}
                    style={{ marginTop: "1.25em" }}
                  >
                    Créer un compte
                  </button>
                </div>
              </div>
            </article>
          )}
          <button
            type="submit"
            style={{ width: "100%" }}
            className={`button is-primary field ${loading && "is-loading"}`}
          >
            Connexion
          </button>
        </form>

        <div
          className="is-divider"
          data-content="Vous n'avez pas de compte ?"
        />
        <button
          type="button"
          style={{ width: "100%" }}
          className="button is-primary is-light field is-outlined"
          onClick={() => history.push(ROUTES.CREATE_ACCOUNT)}
        >
          Créer un compte
        </button>
      </div>
      {settings && settings.homeMessage && (
        <>
          <div className="is-divider-vertical" />
          <div
            className="pz-message"
            dangerouslySetInnerHTML={{ __html: settings.homeMessage.html || settings.homeMessage }}
          />
        </>
      )}
    </div>
  )
}

export default Login
